import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function BreakdownPage() {
  const [rows, setRows] = useState([]);
  const [machines, setMachines] = useState([]);
  const [data, setData] = useState({
    machine: "",
    description: "",
    breakdown_date: "",
    downtime_hours: ""
  });

  useEffect(() => {
    fetchBreakdowns();
    fetchMachines();
  }, []);

  const fetchBreakdowns = () => {
    axios.get(baseUrl + "breakdowns/")
      .then(res => setRows(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch breakdowns", "error"));
  };

  const fetchMachines = () => {
    axios.get(baseUrl + "machines/")
      .then(res => setMachines(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch machines", "error"));
  };

  const inputHandler = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const formSubmit = () => {
    if (!data.machine || !data.description || !data.breakdown_date || !data.downtime_hours) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("machine", data.machine);
    _formData.append("description", data.description);
    _formData.append("breakdown_date", data.breakdown_date);
    _formData.append("downtime_hours", data.downtime_hours);
    _formData.append("resolved", false);
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "breakdowns/", _formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then(res => {
        Swal.fire({ title: "Breakdown Added", icon: "success", timer: 2000, showConfirmButton: false });
        setData({ machine: "", description: "", breakdown_date: "", downtime_hours: "" });
        fetchBreakdowns();
      })
      .catch(() => Swal.fire("Error", "Something went wrong", "error"));
  };

  const handleDelete = (id) => {
    Swal.fire({ title: "Confirm", text: "Are you sure?", icon: "warning", showCancelButton: true, confirmButtonText: "Yes" })
      .then(result => {
        if (result.isConfirmed) {
          axios.delete(baseUrl + "breakdowns/" + id + "/")
            .then(() => { Swal.fire("Deleted", "Breakdown deleted", "success"); fetchBreakdowns(); });
        }
      });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "machine", headerName: "Machine", width: 150, renderCell: (params) => params.row.machine?.name || "Unknown" },
    { field: "description", headerName: "Description", width: 150 },
    { field: "breakdown_date", headerName: "Date", width: 150 },
    { field: "downtime_hours", headerName: "Downtime (hrs)", width: 150 },
    {
      field: "edit", headerName: "Edit", renderCell: (params) => (
        <Link to={`/breakdown/edit/${params.row.id}`} target="_blank" className="btn btn-warning btn-sm">Edit</Link>
      ), width: 120
    },
    {
      field: "delete", headerName: "Delete", renderCell: (params) => (
        <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm">Delete</button>
      ), width: 120
    }
  ];

  return (
    <div className="container mt-4">
      {/* Form */}
      <div className="card p-4 mb-4">
        <h4>Add Breakdown</h4>

        <select name="machine" value={data.machine} onChange={inputHandler} className="form-control mt-3">
          <option value="">Select Machine</option>
          {machines.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
        </select>

        <input type="date" className="form-control mt-3" name="breakdown_date" value={data.breakdown_date} onChange={inputHandler} />
        <input type="number" className="form-control mt-3" placeholder="Downtime Hours" name="downtime_hours" value={data.downtime_hours} onChange={inputHandler} />
        <textarea className="form-control mt-3" placeholder="Description" name="description" value={data.description} onChange={inputHandler}></textarea>

        <button className="btn btn-success mt-3" onClick={formSubmit}>Submit</button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid rows={rows} columns={columns} pageSize={10} autoHeight components={{ Toolbar: GridToolbar }}
          sx={{ boxShadow: 4, border: 4, borderColor: "primary.light", "& .MuiDataGrid-cell:hover": { color: "primary.main" } }}
        />
      </div>
    </div>
  );
}

export default BreakdownPage;
